import type { RumConfiguration } from '@picsart/datadog-rum';

export const datadogConfiguration: RumConfiguration = {
  initParams: {
    service: import.meta.env.VITE_APP_DD_SERVICE,
    env: import.meta.env.VITE_APP_DD_ENV,
    version: import.meta.env.VITE_APP_VERSION,
  },
  globalContext: {
    type: 'miniapp',
    team: 'genai',
  },
};
